import { ContextType, ReactNode } from "react";
import { currentTaskContext, CurrentTaskContextValue } from "./useCurrentTask";

export function CurrentTaskProvider({ children, value }: { children: ReactNode, value: CurrentTaskContextValue }) {
    return <currentTaskContext.Provider children={children} value={value} />;
}